/* Fresca — combo section: "price drop" count-down, offer-card spotlight and off-screen motion pausing
   (progressive enhancement: without this file the real price, card and loops all still render). */
(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const hasIO = 'IntersectionObserver' in window;

  const parse = (s) => {
    const m = String(s || '').match(/\d[\d,]*(?:\.(\d+))?/);
    return m ? { n: parseFloat(m[0].replace(/,/g, '')), raw: m[0], dec: m[1] ? m[1].length : 0 } : null;
  };

  /* The real price stays in .fr-combo__live (and in the .fr-sr copy screen readers get) until the drop
     actually plays; only then does it flip to the regular price and count down to the combo price. */
  const priceDrop = (el) => {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    const live = el.querySelector('.fr-combo__live');
    const sizer = el.querySelector('.fr-combo__sizer');
    const tpl = el.dataset.to || '';
    const to = parse(tpl), from = parse(el.dataset.from);
    if (reduced || !live || !to || !from || from.n <= to.n || !hasIO) return;
    const fmt = (v) => tpl.replace(to.raw, v.toLocaleString('en-US', { minimumFractionDigits: to.dec, maximumFractionDigits: to.dec }));
    const widest = fmt(from.n);
    // reserve the widest state so the count never shifts layout
    if (sizer && widest.length > sizer.textContent.length) sizer.textContent = widest;

    const run = () => {
      const dur = 1300, hold = 260;
      let t0 = 0;
      live.textContent = widest;
      el.classList.add('is-counting');
      const tick = (t) => {
        if (!t0) t0 = t + hold;
        const p = Math.max(0, Math.min(1, (t - t0) / dur));
        const e = 1 - Math.pow(1 - p, 3);
        const v = from.n + (to.n - from.n) * e;
        live.textContent = p < 1 ? fmt(to.dec ? v : Math.round(v)) : tpl;
        if (p < 1) requestAnimationFrame(tick);
        else { el.classList.remove('is-counting'); el.classList.add('is-dropped'); }
      };
      requestAnimationFrame(tick);
    };

    // start as soon as most of the price is on screen — also after an anchor jump that lands it low in the viewport
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((en) => en.isIntersecting)) return;
      io.disconnect();
      run();
    }, { threshold: 0.6 });
    io.observe(el);
  };

  const spotlight = (card) => {
    if (!fine || reduced || card.dataset.lit) return;
    card.dataset.lit = '1';
    card.addEventListener('pointermove', (e) => {
      const r = card.getBoundingClientRect();
      card.style.setProperty('--mx', `${e.clientX - r.left}px`);
      card.style.setProperty('--my', `${e.clientY - r.top}px`);
      card.classList.add('is-lit');
    });
    card.addEventListener('pointerleave', () => card.classList.remove('is-lit'));
  };

  // pause the ambient loops (rings, seal, halo, leaves, sparks, beam) while the section is off-screen
  const idle = (sec) => {
    if (sec.dataset.idleObs || !hasIO) return;
    sec.dataset.idleObs = '1';
    new IntersectionObserver(([en]) => sec.classList.toggle('is-idle', !en.isIntersecting), { rootMargin: '120px 0px' }).observe(sec);
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-combo-section]').forEach(idle);
    root.querySelectorAll('.fr-combo [data-combo-price]').forEach(priceDrop);
    root.querySelectorAll('.fr-combo [data-combo-deal]').forEach(spotlight);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
